import { atom } from "jotai";

import { RestaurantEquippersService } from "./restaurant-equippers.service";
import { CompletionStatus, Pages } from "./restaurant-equippers.types";

export const pagesAtom = atom<Pages>(Pages.SMS_FORM);
export const smsCompletedAtom = atom<boolean>(false);
export const companyFormCompletedAtom = atom<boolean>(false);

export const completionStatusAtom = atom<CompletionStatus | null>(async () => {
  const submission = window.theme.Sweepstake.prototype.retrieveSubmission();
  const userEmail = submission?.data?.email;

  if (!userEmail) {
    return null;
  }

  return RestaurantEquippersService.getCompletionStatus(userEmail);
});
